import { Trans, useLingui } from '@lingui/react/macro';
import { Label } from '@utima/ui';

import { Alert } from '@/components/Alert';
import {
  createDocumentUploadAdapter,
  FileUpload,
} from '@/components/fileUpload';
import { llamaAcceptFiles } from '@/components/fileUpload/llamaAcceptFiles';

export type UploadDocumentsProps = {
  chatIds: string[];
  availableForAllAgents: boolean;
  limitReached: boolean;
  projectedLimitReached: boolean;
  folderId?: string | null;
  onFilesDropped?: () => void;
};

export function UploadDocuments({
  chatIds,
  availableForAllAgents,
  limitReached,
  projectedLimitReached,
  folderId,
  onFilesDropped,
}: UploadDocumentsProps) {
  const { t } = useLingui();
  const uploadAdapter = createDocumentUploadAdapter(
    chatIds,
    availableForAllAgents,
    folderId,
  );

  return (
    <div className='flex h-full flex-col justify-between gap-2'>
      {limitReached && (
        <Alert
          variant='warning'
          title={t`Document Limit Reached`}
          className='mb-4'
        >
          <Trans>
            You have reached the maximum document limit for your plan. File
            upload is disabled.
          </Trans>
        </Alert>
      )}

      <Label className='text-xs font-medium text-muted-fg'>
        <Trans>…or drop files here / click to browse</Trans>
      </Label>

      <div className='grow'>
        <FileUpload
          uploadAdapter={uploadAdapter}
          fullScreenDrop
          onFilesDropped={onFilesDropped}
          accept={llamaAcceptFiles}
          maxSize={50 * 1024 * 1024}
          disabled={limitReached || projectedLimitReached}
        />
      </div>
    </div>
  );
}
